import { SWReactIcons } from "@similarweb/icons";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import { StyledTabWithCounter, StyledTabWithCounterIconWrap, StyledTabWithCounterNumberOfResults } from "./styles";
import TabNumberOfResults from "./TabNumberOfResults";
import type { TabWithCounterProps } from "./types";

const TabWithCounter = ({
    total,
    isLoading,
    iconNameActive,
    iconNameInactive,
    isSelected,
    title,
    withIconFill = false,
    formatNumber,
}: TabWithCounterProps) => {
    return (
        <StyledTabWithCounter>
            <StyledTabWithCounterIconWrap withIconFill={withIconFill}>
                <SWReactIcons
                    iconName={isSelected ? iconNameActive : iconNameInactive}
                    size="xs"
                />
            </StyledTabWithCounterIconWrap>
            <StyledTabWithCounterNumberOfResults>
                <I18n translatable={title} />
                <TabNumberOfResults
                    total={total}
                    isLoading={isLoading}
                    formatNumber={formatNumber}
                />
            </StyledTabWithCounterNumberOfResults>
        </StyledTabWithCounter>
    );
};

export default TabWithCounter;
